<script>
  import Router from "svelte-spa-router";
  import { routes } from "./routes.js";
  import Tailwind from "./Tailwind.svelte";
  import NavBar from "./components/NavBar.svelte";
  import Footer from "./components/Footer.svelte";
  import SessionExpiredModal from "./components/SessionExpiredModal.svelte";
  import ErrorBox from "./components/common/ErrorBox.svelte";
  import LoadingInfo from "./components/LoadingInfo.svelte";
  import { onMount, onDestroy } from "svelte";
  import {
    isMobile,
    locale,
    sessionExpiredModalShown,
    errorBox,
  } from "./store/stores.js";
  import { getHasAccess, startAuthWatcher, stopAuthWatcher  } from "./login.js";
  import { updateLanguage, t } from "./i18n";

  if (!$locale || $locale === "null") {
    updateLanguage("fi");
  }
  // Tämä ajetaan vain kun sivu ladataan
  let promise = getHasAccess();
  let handleVisibility;

  onMount(() => {
    // Käynnistetään säännöllinen tarkistus
    startAuthWatcher();
	isMobile.set(window.innerWidth < 767)

    // Lisätään visibilitychange-tarkistus
    handleVisibility = () => {
      if (document.visibilityState === "visible") {
		// Tämä ajetaan vain kun näkyvyys muuttuu, eli käytännössä palataan toiselta välilehdeltä
		// Alustuksessa ei ajeta, joten ylempänä voi olla toinen getHasAccess()
        getHasAccess();
      }
    };
    document.addEventListener("visibilitychange", handleVisibility);
  });

  onDestroy(() => {
    stopAuthWatcher();
    document.removeEventListener("visibilitychange", handleVisibility);
  });

  window.addEventListener("resize", () => {
    isMobile.set(window.innerWidth < 767);
  });
</script>

<Tailwind />
{#await promise}
  <LoadingInfo />
{:then}
  <main class="min-h-screen flex flex-col">
    {#if $sessionExpiredModalShown}
      <SessionExpiredModal />
    {/if}
    <NavBar />
    <div class="flex-[1] mt-24">
      {#if $errorBox.title !== ""}
        <ErrorBox />
      {/if}
      <Router {routes} />
    </div>
    <Footer />
  </main>
{/await}
